import React from 'react';
import BrandLoader from './BrandLoader';
import './LoadingSpinner.css';

/**
 * Unified Loading Spinner Component
 * Use this component for all loading states across the application.
 *
 * Renders the SAF3AI brand loader (BrandLoader): the shield scan at md/lg, the
 * drawing "3" at sm. A full-page loader is the large shield plus the rotating
 * per-module line.
 *
 * @param {Object} props
 * @param {string} props.message - Optional loading message (a page-wide spinner shows the module's fun line instead of the generic default)
 * @param {string} props.size - Size of spinner: 'sm', 'md', 'lg' (default: 'md'; 'xs' maps to 'sm')
 * @param {boolean} props.fullPage - If true, centers spinner in full page viewport
 * @param {string} props.className - Additional CSS classes
 */
const LoadingSpinner = ({
  message,
  size = 'md',
  fullPage = false,
  className = ''
}) => {
  const containerClass = fullPage
    ? `loading-spinner-container loading-spinner-fullpage ${className}`
    : `loading-spinner-container ${className}`;

  return (
    <div className={containerClass.trim()}>
      {/* `auto`: where the spinner fills a page body it grows into the page
          loader (xl shield + module line); in a card it stays as sized. */}
      <BrandLoader
        variant={fullPage ? 'shield' : undefined}
        size={fullPage ? 'xl' : size}
        message={message}
        defaultMessage="Loading page data..."
        line={fullPage}
        auto={!fullPage}
      />
    </div>
  );
};

export default LoadingSpinner;
